import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";

export const Container = styled.div`
  display: flex;

  font-family: ${fontFredoka};
`;

export const StyledBaseLink = styled(BaseLink)``;
